import { useRef } from 'react'

type useClicksProps<T> = {
  onClick: (item: T) => void
  onDoubleClick: (item: T) => void
}

const useClicks = <T>({ onClick, onDoubleClick }: useClicksProps<T>) => {
  const ref = useRef<number>()

  const handleClick = (item: T) => {
    setTimeout(() => {
      if (ref.current) {
        ref.current--
      } else {
        onClick(item)
      }
    }, 235)
  }

  const handleDoubleClick = (item: T) => {
    ref.current = 2
    onDoubleClick(item)
  }

  return {
    handleClick,
    handleDoubleClick
  }
}

export default useClicks
